<template>
  <div class="layout-page">
    <top id="top-nav" :title="bookTitle" :key="`${bookTitle}-catalog`"></top>
    <section class="aui-scrollView no-foot">
      <van-list
        ref="vanList"
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="getCatalog"
      >
        <ul class="chapter-list">
          <li v-for="(item) in list" :key="item.id">
            <a @click="toChapter(item.bookId, item.number)">
              <h3>第{{item.number}}章 {{item.title}}</h3>
              <div>
                <span v-if="history.number == item.number" class="bg-red">上次阅读</span>
              </div>
              <template v-if="item.alreadyBuy">
                <span class="free">已购买</span>
              </template>
              <template v-else>
                <span class="free" v-if="item.price===0">免费</span>
                <span class="lock" v-else>{{item.price}} 阅币</span>
              </template>
            </a>
          </li>
        </ul>
      </van-list>
    </section>
  </div>
</template>

<script>
import bookService from '../../../services/bookService'
import shelfService from '../../../services/shelfService'
import BookTop from '@/components/layer2/book/book-top'
import { getImg } from '../../../services/urlService'

export default {
  name: 'catagory',
  data () {
    return {
      bookTitle: '',
      loading: false,
      finished: false,
      finishedText: '',
      list: [],
      currentPage: 1,
      bookId: '',
      history: {}
    }
  },
  methods: {
    getCatalog () {
      // bookService.getChapters(this.$route.params.id).then(res => {
      //   const resData = res.data
      //   this.catalog = resData.chapters || []
      // })
      const { currentPage, finished, list, bookId } = this
      if (finished) return
      bookService.getChapters(bookId, currentPage).then(res => {
        this.loading = false
        const resData = res.data || {}
        const chapters = resData.chapters || []
        this.list = list.concat(chapters)
        if (currentPage >= resData.totalPage || chapters.length === 0) {
          this.finished = true
        } else {
          this.currentPage++
        }
      })
    },
    getCover (route) {
      if (route) {
        return getImg(`${route}_180_0.img`)
      }
    },
    getHistory (bookId) {
      this.history = shelfService.getHistoryById(parseInt(bookId)) || {}
    },
    getPriceText (price) {
      if (price === 0 || price === '0') {
        return '免费'
      } else {
        return `${price}  阅币`
      }
    },
    toChapter (bookId, number) {
      this.$router.isBack = false
      this.$router.push({
        path: `/book/read/${bookId}/${number}`,
        query: {
          title: this.$route.query.title,
          title2: this.list.find(item => item.number === number).title
        }
      })
    }
  },
  components: {
    top: BookTop
  },
  mounted () {
    const bookId = this.$route.params.id
    this.bookId = bookId
    this.bookTitle = this.$route.query.title
    this.getHistory(bookId)
    this.$router.isBack = true
  }
}
</script>

<style scoped>
</style>
